import axiosInstance from '../../../../config/axiosInstance';
import { IssueStatusValidation } from "../../View/IssueStatus/Validation/IssueStatusValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
  event.preventDefault();


  const formErrors = IssueStatusValidation(formData);

  setErrors(formErrors);

  if (Object.keys(formErrors).length === 0) {
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        if (key !== 'File') { // Skip the File key, we will handle it separately
          formDataToSend.append(key, formData[key]);
        }
      });

      // Append the file if it exists
      if (formData.File) {
        formDataToSend.append('File', formData.File);
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      const response = await axiosInstance.post(`/SuperAdmin/CreateIssueStatusDefault`, formDataToSend, config);
      
      setFormData({
        StatusName: '',
        IsOutstanding: '',
        IsCompleted: '',
        File: ""
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};


export { handleChange, handleSubmit };

